import $ from 'jquery';
import resetForm from '../utils/reset-form';

export default function meetingForm() {
  const $forms = $('.js-meeting-form');

  if (!$forms.length) return;

  $forms.each(function () {
    $(this).on('submit', function (e) {
      e.preventDefault();

      if ( !$(this).valid() ) return;

      setTimeout(() => {
        $(this).closest('.live-meeting-modal, .live-meeting-page, .js-form-container').addClass('complete');
      }, 100);

      $.post('/process/live-meeting-form.php', $(this).serialize(), () => {
        console.log('completed');
      });
    });

    $('.js-meeting-redo-btn').on('click', function() {
      $(this).closest('.live-meeting-modal, .live-meeting-page, .js-form-container').removeClass('complete');

      // Reset form
      const $form = $(this).closest('.js-form-container').find('.js-meeting-form');
      resetForm($form);
    });
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/meeting-form.js